import { VideoLessonVisor } from '@oneclick/react-videolesson';
import { useUser } from 'core/lite/hooks/useUser';
import PropTypes from 'prop-types';
import React from 'react';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';

function MaterialPreviewVideoLesson({ material }) {
  const { authToken } = useUser();
  const video = typeof material.content_data === 'string' ? JSON.parse(material.content_data) : material.content_data;
  const questions = video?.questions ? Object.values(video.questions) : [];
  const configVisor = { lang: 'es', authToken: authToken };
  return (
    <div className="video-lesson">
      <div className="video-lesson-content">
        <div className="material-preview-video-lesson">
          <div className="material-preview-quiz">
            <div className="mb-4">
              <VideoLessonVisor configVisor={configVisor} onChangeResponses={() => {}} videolesson={video} />
            </div>

            {questions?.map((question, index) => (
              <div key={question?.content_guid} className="material-preview-quiz__item mb-3">
                <div>
                  <span className="material-preview-quiz__box">{index + 1}</span>
                </div>

                <TextHtml text={question?.data?.stimulus} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

MaterialPreviewVideoLesson.propTypes = {
  material: PropTypes.shape({
    content_data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  }).isRequired,
};

export default MaterialPreviewVideoLesson;
